<template>
    <b-modal id="register-user-modal" centered header-bg-variant="primary" @ok="registerUser">

        <div slot="modal-header" class="w-100">
            <h2 class="text-center">Register</h2>
        </div>

        <p>Please fill the following fields properly to register your account</p>

        <b-form-group
                id="fieldset1"
                label-for="email-input"
                :invalid-feedback="invalidEmailFeedback"
                :valid-feedback="validEmailFeedback"
                f :state="emailState"
        >
            <b-input-group>
                <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="email-input" placeholder="Enter email" :state="emailState"
                              v-model.trim="email"></b-form-input>
            </b-input-group>
        </b-form-group>

        <b-form-group
                id="fieldset2"
                label-for="password-input"
                :invalid-feedback="invalidPasswordFeedback"
                :valid-feedback="validPasswordFeedback"
                f :state="passwordState"
        >
            <b-input-group>
                <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="password-input" type="password" placeholder="Enter password" :state="passwordState"
                              v-model.trim="password"></b-form-input>
            </b-input-group>

        </b-form-group>

        <b-form-group
                id="fieldset3"
                label-for="password-confirmation-input"
                :invalid-feedback="invalidPasswordConfirmationFeedback"
                :valid-feedback="validPasswordConfirmationFeedback"
                f :state="passwordConfirmationState"
        >
            <b-input-group>
                <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="password-confirmation-input" type="password" placeholder="Confirm password"
                              :state="passwordConfirmationState"
                              v-model.trim="passwordConfirmation"></b-form-input>
            </b-input-group>
        </b-form-group>

        <div slot="modal-ok">Confirm</div>
    </b-modal>
</template>

<script>
    export default {
        name: "Modal",

        data() {
            return {
                email: "",
                password: "",
                passwordConfirmation: "",
            }
        },

        computed: {
            emailState() {
                let re = /[^\s@]+@[^\s@]+\.[^\s@]+/;
                return re.test(this.email);
            },
            invalidEmailFeedback() {
                if (this.email.length > 0) {
                    return "Your email is not formatted properly.";
                } else {
                    return 'Email must not be empty'
                }
            },
            validEmailFeedback() {
                return this.emailState === true ? 'Your email is formatted properly.' : ''
            },

            passwordState() {
                return this.password.length >= 6 ? true : false
            },
            invalidPasswordFeedback() {
                if (this.password.length > 6) {
                    return ''
                } else if (this.password.length > 0) {
                    return 'Enter at least 6 characters'
                } else {
                    return 'Password must not be empty'
                }
            },
            validPasswordFeedback() {
                return this.passwordState === true ? 'Correct' : ''
            },

            passwordConfirmationState() {
                return this.passwordConfirmation.length >= 6 ? true : false
            },
            invalidPasswordConfirmationFeedback() {
                if (this.passwordConfirmation.length > 6) {
                    return ''
                } else if (this.passwordConfirmation.length > 0) {
                    return 'Enter at least 6 characters'
                } else {
                    return 'Confirmation password must not be empty'
                }
            },
            validPasswordConfirmationFeedback() {
                return this.passwordConfirmationState === true ? 'Correct' : ''
            }
        },

        methods: {
            registerUser(bvEvt) {
                this.$axios({
                    method: 'post',
                    url: '/register',
                    data: {
                        'email': this.email,
                        'password': this.password,
                        'passwordConfirmation': this.passwordConfirmation

                    },
                    timeout: 10000
                }).then(response => {
                    this.$root.$emit('showInfo', response.data);
                    this.$root.$emit('bv::show::modal', 'info-modal');
                }).catch((err) => {
                    let error = err.response.data;
                    if (error.type === "ValidationError") {

                        this.$root.$emit('showError', error.body);
                    } else {
                        this.$root.$emit('showError', error);
                    }
                    this.$root.$emit('bv::show::modal', 'error-modal');
                }).finally(() => {
                });
            },
        }
    }
</script>
